const bottomCategoryBtn = document.querySelector(".bottom-nav-item.nav_categoriess");

if (bottomCategoryBtn) {
  bottomCategoryBtn.addEventListener("click", () => {
    document.querySelector("header-drawer")?.querySelector("summary")?.click();

    const panel = document.querySelector("#menu-drawer");
    if (panel) {
      panel.classList.add("open");
    }
  });
}

// const catButton = document.querySelector('.nav_categories');

// // Function to close the drawer
// function closeDrawer() {
//   const drawerValue = document.querySelector('#category-drawer');
//   if (drawerValue.classList.contains('animate') && drawerValue.classList.contains('active')) {
//     drawerValue.classList.remove('animate', 'active');
//   }
// }

// catButton.addEventListener('click', () => {
//   window.history.pushState({ page: "drawer-open" }, "", window.location.href + "?state=drawer-open");
// });

// window.addEventListener('popstate', (event) => {
//   closeDrawer();
//   if (event.state && event.state.page === "drawer-open") {
//     // Remove the state from the window history
//     window.history.replaceState(null, "", window.location.href);
//   }
// });

// window.addEventListener('hashchange', (event) => {
//   closeDrawer();
//   if (event.state && event.state.page === "drawer-open") {
//     // Remove the state from the window history
//     window.history.replaceState(null, "", window.location.href);
//   }
// });



const catButton = document.querySelector('.nav_categories');
const drawerCloseButton = document.getElementById('category-drawer-close');

// Function to close the drawer
function closeDrawer() {
  const drawerValue = document.querySelector('#category-drawer');
  if (drawerValue.classList.contains('animate') && drawerValue.classList.contains('active')) {
    drawerValue.classList.remove('animate', 'active');
  }
}

// Function to handle the state change and remove the state from the window history
function handleStateChange() {
  closeDrawer();
  if (window.history.state && window.history.state.page === "drawer-open") {
    // Remove the state from the window history
    window.history.replaceState(null, "", window.location.href);
  }
}

catButton?.addEventListener('click', () => {
  window.history.pushState({ page: "drawer-open" }, "", window.location.href + "?state=drawer-open");
});

drawerCloseButton.addEventListener('click', () => {
  closeDrawer();
  if (window.history.state && window.history.state.page === "drawer-open") {
    // Remove the state from the window history
    window.history.replaceState(null, "", window.location.href.replace(/\?state=drawer-open$/, ""));
  }
});

window.addEventListener('popstate', handleStateChange);
window.addEventListener('hashchange', handleStateChange);
